"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSettings = void 0;
const parseSettings = (settings) => {
    var _a, _b;
    let settingsObj;
    try {
        settingsObj = JSON.parse(settings);
    }
    catch (error) {
        settingsObj = settings;
    }
    const parsedSettings = [];
    for (let i = 0; i < settingsObj.length; i++) {
        const setting = settingsObj[i];
        if (setting.type == 1) {
            parsedSettings.push(Object.assign({ type: setting.type, description: setting.description }, (setting.user
                ? {
                    userPreferance: {
                        value: setting.user,
                        enabled: setting.user,
                    },
                }
                : { default: setting.default })));
        }
        else if (setting.type == 2) {
            parsedSettings.push(Object.assign({ type: setting.type, description: setting.description, data: {
                    upper: setting.upperLimit,
                    lower: setting.lowerLimit,
                    ticker: (_a = setting.ticker) !== null && _a !== void 0 ? _a : 1,
                } }, (setting.user
                ? {
                    userPreferance: {
                        value: setting.user,
                        enabled: setting.enabled,
                    },
                }
                : { default: setting.default })));
        }
        else if (setting.type == 3) {
            parsedSettings.push(Object.assign({ type: setting.type, description: setting.description, data: {
                    upper: setting.upperLimit,
                    lower: setting.lowerLimit,
                    ticker: (_b = setting.ticker) !== null && _b !== void 0 ? _b : 1,
                } }, (setting.user
                ? {
                    userPreferance: {
                        value: setting.user,
                        enabled: setting.enabled,
                    },
                }
                : { default: setting.default })));
        }
    }
    return parsedSettings;
};
exports.parseSettings = parseSettings;
//# sourceMappingURL=parseSettings.js.map